import { Link } from "react-router-dom";
import FadeInSection from "./FadeInSection";
import logoWhite from "@/assets/logo-white.png";

const Footer = () => {
  return (
    <footer className="bg-foreground text-primary-foreground" aria-label="Site footer">
      <div className="section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <FadeInSection>
            <img
              src={logoWhite}
              alt="AV Design International"
              width={160}
              height={56}
              loading="lazy"
              className="h-14 w-auto mb-6"
            />
            <p className="text-sm font-body font-light leading-relaxed text-primary-foreground/60">
              Crafting immersive experiences that redefine how you engage with 
              architecture and design. Dubai · Krakow.
            </p>
          </FadeInSection>

          <FadeInSection delay={0.1}>
            <h3 className="font-heading text-xl tracking-widest mb-6">Navigation</h3>
            <div className="flex flex-col gap-3">
              {["About", "Portfolio", "Services", "Calculator", "Media", "Contact"].map((item) => (
                <Link
                  key={item}
                  to={`/${item.toLowerCase()}`}
                  className="text-sm font-body font-light text-primary-foreground/60 hover:text-accent transition-colors tracking-wide"
                >
                  {item}
                </Link>
              ))}
            </div>
          </FadeInSection>

          <FadeInSection delay={0.2}>
            <h3 className="font-heading text-xl tracking-widest mb-6">Dubai, UAE</h3>
            <address className="text-sm font-body font-light not-italic text-primary-foreground/60 space-y-2">
              <p>P.O Box 410492, Dubai, UAE</p>
              <p><a href="tel:+971502112584" className="hover:text-accent transition-colors">+971 50 2112584</a></p>
              <p><a href="mailto:info@avdesignintl.com" className="hover:text-accent transition-colors">info@avdesignintl.com</a></p>
            </address>
          </FadeInSection>

          <FadeInSection delay={0.3}>
            <h3 className="font-heading text-xl tracking-widest mb-6">Krakow, Poland</h3>
            <address className="text-sm font-body font-light not-italic text-primary-foreground/60 space-y-2">
              <p>Krakow, Poland</p>
              <p><a href="tel:+48782244934" className="hover:text-accent transition-colors">+48 782 244 934</a></p>
              <p><a href="mailto:europe@avdesignintl.com" className="hover:text-accent transition-colors">europe@avdesignintl.com</a></p>
            </address>
          </FadeInSection>
        </div>

        <div className="border-t border-primary-foreground/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-body font-light text-primary-foreground/40 tracking-wider">
            © {new Date().getFullYear()} AV Design International. All rights reserved.
          </p>
          <div className="flex gap-6">
            {[
              { name: "LinkedIn", href: "https://ae.linkedin.com/company/av-design-international" },
              { name: "Instagram", href: "https://www.instagram.com/avdesignintl" },
              { name: "Facebook", href: "https://www.facebook.com/Avdesignintl/" },
            ].map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`AV Design International on ${social.name} (opens in new tab)`}
                className="text-xs font-body font-light text-primary-foreground/40 hover:text-accent transition-colors tracking-wider uppercase focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
              >
                {social.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
